import * as types from '../../action-types';
import { updateOffer as initialState } from "../../initialState";

const updateOffer = (state=initialState, action) => {
  switch (action.type) {
    case types.UPDATE_OFFER_START:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_OFFER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.UPDATE_OFFER_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_OFFER_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default updateOffer;
